
import { Component, Prop, Watch } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import ListBase from '@/lib/listbase';
import ManufacturerModel from '@/store/entities/admin/manufacturer-model';
import Util from '@/lib/util';

@Component({
    components: {
        ModalView,
        FormBase,
    },
})
export default class ManufacturerModelForm extends ListBase {
    @Prop({ type: Boolean, default: false }) readonly value!: boolean;

    modalShow: boolean = false;

    manufacturer: ManufacturerModel = new ManufacturerModel();

    modalSetting: any = {
        entity: 'manufacturer-models',
        title: 'Modelo',
        width: '500px',
        showForm: false,
    };

    items = [
        this.gItem({
            type: 'select',
            prop: 'manufacturer_id',
            label: 'Marca',
            size: 12,
            required: true,
            items: this.listMans,
            itemValue: 'id',
            itemText: 'name',
        }),
        this.gItem({
            type: 'text',
            prop: 'model',
            label: 'Modelo',
            size: 12,
            required: true,
        }),
    ];

    @Watch('value')
    onValueChange(val: boolean) {
        this.modalShow = val;
        if (val) {
            this.manufacturer = Util.extend(
                true,
                {},
                this.$store.state['manufacturer-models'].editModel || new ManufacturerModel()
            );
            this.initForm();
        } else {
            this.$emit('input', false);
        }
    }

    @Watch('modalShow')
    onModalShowChange(val: boolean) {
        if (!val) {
            this.$emit('input', false);
        }
    }

    get listMans() {
        return this.$store.state.manufacturer.activeList;
    }

    initForm() {
    }


    async save() {
        const form = this.$refs.entityForm1 as any;
        if (!form.validate()) return;

        const payload = {
            manufacturer_id: (this.manufacturer as any).manufacturer_id,
            model: (this.manufacturer as any).model,
        };

        if (this.manufacturer.id) {
            await this.$store.dispatch('manufacturer-models/update', {
                data: {
                    id: this.manufacturer.id,
                    ...payload,
                }
            });
        } else {
            await this.$store.dispatch('manufacturer-models/create', { data: payload });
        }

        this.$emit('save-success');
        this.cancel();
    }

    cancel() {
        this.$emit('input', false);
    }
}
